export const notificationConstants = {
  NIP_REQUEST: 'NIP_REQUEST',
  NIP_SUCCESS: 'NIP_SUCCESS',
  NIP_FAILURE: 'NIP_FAILURE',

  NIP_UPDATE_REQUEST: 'NIP_UPDATE_REQUEST',
  NIP_UPDATE_SUCCESS: 'NIP_UPDATE_SUCCESS',
  NIP_UPDATE_FAILURE: 'NIP_UPDATE_FAILURE',

  NOTIFICATION_CHANGEPASS_REQUEST: 'NOTIFICATION_CHANGEPASS_REQUEST',
  NOTIFICATION_CHANGEPASS_SUCCESS: 'NOTIFICATION_CHANGEPASS_SUCCESS',
  NOTIFICATION_CHANGEPASS_FAILURE: 'NOTIFICATION_CHANGEPASS_FAILURE',

  SENDNIP_REQUEST: 'SENDNIP_REQUEST',
  SENDNIP_SUCCESS: 'SENDNIP_SUCCESS',
  SENDNIP_FAILURE: 'SENDNIP_FAILURE',

  QR_IMAGE_REQUEST: 'QR_IMAGE_REQUEST',
  QR_IMAGE_SUCCESS: 'QR_IMAGE_SUCCESS',
  QR_IMAGE_FAILURE: 'QR_IMAGE_FAILURE',
}
